import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AbstractControlWithWarnings } from "@mrdm-self-service-frontend/shared/types";

export const EMAIL_REGEXP = /^[\w]+([+.-][\w]+)*@[\w]+([-.][\w]+)*\.[a-zA-Z]{2,63}$/;

export function emailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();
    if (value == null || value.length === 0) {
        return null;
    }
    return EMAIL_REGEXP.test(value) ? null : { email: true };
}

export const emailAllowedDomainWarning = (allowedDomains: () => string[]) => {
    return (control: AbstractControlWithWarnings): null => {
        if (!control.value) return null;

        const value = control.value.toLowerCase();

        const domains = allowedDomains();

        const allowed = domains.length
            ? domains.some(domain => value.endsWith(`@${domain.toLowerCase()}`))
            : true;

        // in case of error fill warning property
        control.warnings = allowed ? null : { domainNotAllowed: true };

        // input should remain valid
        return null;
    };
};

export const accountExistsValidator = (usedEmails: () => string[]) => {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;

        const value = control.value.toLowerCase();

        const exists = usedEmails().some(email => email.toLowerCase() === value);

        return exists ? { accountExists: true } : null;
    };
};

export const duplicateInviteValidator = (usedEmails: () => string[]) => {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;

        const value = control.value.toLowerCase();

        const count = usedEmails().filter(email => email.toLowerCase() === value).length;

        return count > 1 ? { inviteDuplicated: true } : null;
    };
};
